import { RoutePaths } from '../constants';
import { fetchAuthSession } from 'aws-amplify/auth';
import axios, { HttpStatusCode } from 'axios';
import { AppDispatch } from 'store';
import { resetStateActionCreator } from 'store/actionCreators';
import { authActions } from 'store/auth/slice';

const baseURL = process.env.REACT_APP_API_URL;
const publicPath = '/public';
const apiPath = '/api/v1';

export const controller = new AbortController();

const config = {
  baseURL,
  signal: controller.signal,
  headers: {
    'Content-Type': 'application/json',
  },
};

enum Paths {
  USERS = '/users',
  PATIENT_CASE = '/patient-cases',
  FILES = '/files',
  FCM = '/fcm',
}

enum Errors {
  USER_IS_BLOCKED = 'User for authentication is blocked',
}

const apiInstance = axios.create(config);

const setToken = async () => {
  const token = (await fetchAuthSession()).tokens?.accessToken.toString();
  apiInstance.defaults.headers.common = {
    ...apiInstance.defaults.headers.common,
    ...{ Authorization: `Bearer ${token ?? ''}` },
  };
};

const getPath = (servicePath: string, isPublic = false) => {
  return `${servicePath}${isPublic ? publicPath : ''}${apiPath}`;
};

export const apiClient = { Paths, apiInstance, getPath, setToken };

export const setupInterceptors = (dispatch: AppDispatch) =>
  apiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error.response ? error.response.status : null;

      if (status === HttpStatusCode.Unauthorized) {
        if (error?.response?.data?.title === Errors.USER_IS_BLOCKED) {
          await dispatch(authActions.signOut());
          dispatch(resetStateActionCreator());
          return;
        }

        const accessToken = (await fetchAuthSession()).tokens?.accessToken.toString();

        if (!accessToken) {
          window.location.pathname === RoutePaths.LOGIN &&
            window.location.replace(window.location.origin + RoutePaths.LOGIN);
          return;
        }

        error.config.headers.Authorization = 'Bearer ' + accessToken;
        error.config.baseURL = config.baseURL;

        return apiInstance.request(error.config);
      }

      return Promise.reject(error);
    },
  );
